import { FC } from 'react';

import { ORDER_CART_TEST_ID } from '../../constants';
import { CartTotalsNotificationData } from '../../model';
import { CartTotalsNotificationContainer } from './CartTotalsNotification.styles';

export const CartTotalsNotification: FC<CartTotalsNotificationData> = ({ content }) => {
    return (
        <CartTotalsNotificationContainer data-test={ORDER_CART_TEST_ID.TOTALS_NOTIFICATION}>
            {content}
        </CartTotalsNotificationContainer>
    );
};
